import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=40c1fb44&scoped=true"
import script from "./sidebar.vue?vue&type=script&lang=ts"
export * from "./sidebar.vue?vue&type=script&lang=ts"
import style0 from "./sidebar.vue?vue&type=style&index=0&id=40c1fb44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_762a4ceba611ab1d58a92326b3604e6f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c1fb44",
  null
  
)

export default component.exports